import firebase from 'firebase/app';
import "firebase/firestore";



var firebaseConfig = {
    apiKey: "AIzaSyCPsNZX2tmbBV3wQIZmrvBH1XU9HzsPrLU",
    authDomain: "my-interests-blogs.firebaseapp.com",
    projectId: "my-interests-blogs",
    storageBucket: "my-interests-blogs.appspot.com",
    messagingSenderId: "187123523040",
    appId: "1:187123523040:web:3d36fadd4fbfbd82045f85"
  };

  const firebaseApp = firebase.initializeApp(firebaseConfig);
  const timestamp = firebase.firestore.FieldValue.serverTimestamp;
  
    export { timestamp };
    export default firebaseApp.firestore();
  
  